import { render, staticRenderFns } from "./Accordeon.vue?vue&type=template&id=201331ba&scoped=true"
import script from "./Accordeon.vue?vue&type=script&lang=js"
export * from "./Accordeon.vue?vue&type=script&lang=js"
import style0 from "./Accordeon.vue?vue&type=style&index=0&id=201331ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201331ba",
  null
  
)

export default component.exports